import React from 'react'
import PageHeader from '../components/Header'
// import UserDetail from "../components/UserDetail"
// import PageSlider from "../components/Slider"
// import WelcomePage from "../components/WelcomePage"
// import Selector from "../components/Selector"
// import FreeTrial from "../components/FreeTrial"
import PageFooter from '../components/Footer'
import TopQuestions from '../components/TopQuestions'
import HeaderImage from '../components/HeaderImage'

const Faq = () => {
  // const dispatch = useDispatch()
  // const { userProfile } = useSelector((state) => state)
  // const debug = JSON.stringify(userProfile, null, 2)

  // const [hasRoles, setHasRoles] = useState(false)
  // const [hasAwards, setHasAwards] = useState(false)
  // const [hasAdultRanks, setHasAdultRanks] = useState(false)

  // useEffect(() => {
  //     if (userProfile.roles) { setHasRoles(true) }
  //     if (userProfile.awards) { setHasAwards(true) }
  //     if (userProfile.adultRanks) { setHasAdultRanks(true) }
  // }, [userProfile])

  return (
    <div>
      <PageHeader />
      <HeaderImage
        maintitle="Načastejšie kladené otázky"
        subtitle="TOP 10 otázok"
        img="images/general-bg-kids.jpg"
      />
      <TopQuestions />
      <PageFooter />
    </div>
  )
}

export default Faq
